// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"258b012d","821":"4f4a965c"}[chunkId] + ".chunk.js";
};